$('[data-autocomplete]').autocomplete({
	serviceUrl: '/wp-json/m6press/v1/search/',
	minChars: 3,
	groupBy: 'group',
	maxHeight: 800,
	params: {
		type: 'all'
	},
	transformResult: function(response) {
		return JSON.parse(response);
	},
	formatResult: function (suggestion, currentValue) {
		if (!currentValue)
			return suggestion.value;

		var re = new RegExp(currentValue,'gi');
		var value = '<span>' + suggestion.value.replace(re, '<strong>$&<\/strong>') + '</span>';

		value = suggestion.data.img ? '<img src="' + suggestion.data.img.tiny + '"> ' + value : value;

		value = suggestion.data.object_type == 'location_tax' ? '<span class="icon-city"></span> ' + value : value;

		return value;
	},
	appendTo: '.search',
	onSelect: function(suggestion) {
		if(suggestion.data.url)
			window.location.href = suggestion.data.url;

		if(suggestion.data.object_type == 'location_tax')
			displayResults('/wp-json/m6press/v1/search/', { city: suggestion.data.id });
	},
	showNoSuggestionNotice: true,
	noSuggestionNotice: 'Aucun résultat',
});

$('[data-autocomplete]').on('keydown', function(e) {
	var value = $(this).val();

	if(event.which == 13 || event.keyCode == 13)
		displayResults('/wp-json/m6press/v1/search/', { query: value, type: 'restaurant' });
});

$('[data-search-button]').on('click', function(e) {
	var value = $('[data-autocomplete]').val();

	displayResults('/wp-json/m6press/v1/search/', { query: value, type: 'restaurant' });
});

$('[data-autocomplete]').on('change', function(e) {
	var cond = $(this).val() !== '';
	$(this).toggleClass('filled', cond);
});

var displayResults = function(restUrl, params) {
	$('[data-search-results]').html('');
	$('[data-search-results]').closest('section').addClass('show');
	$.get(restUrl, params)
	.done(function(data) {
		if(!data.suggestions.length)
			$('[data-search-results]').html('<div class="col noresult">Aucun résultat</div>');

		$.each(data.suggestions, function(i,e) {
			var html = $('[data-search-results]').html() + m6PostCard(e, 3);
			$('[data-search-results]').html(html);
		});
		$(window).lazyLoadXT();
	});
}